// NotificacionInventarioPage.tsx

import { PermissionsEnum } from "@/auth/interfaces";
import { hasPermission, sizeTab, a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { TableNotificacionInventario } from "../../components";

export default function NotificacionInventarioPage() {

  hasPermission(PermissionsEnum.api_view_notificacioninventario)

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title={"📣 Notificacion Inventario"}
      py={2}
      visibleReport={true}
    >
      <TableNotificacionInventario modulo="TECNICO" />
    </SingleTableBoxScene >
  )
}